const routes = [
	{
		path: '/center/TeachingMaterial/home',
		component: () =>
			import('../views/TeachingMaterial/Home.vue')
	}
];

export default {
	routes
};
